
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.65 6.35a7.95 7.95 0 00-6.48-2.31 8 8 0 108.04 11.4 1 1 0 00-.9-1.44.973.973 0 00-.88.53A6 6 0 1112 6a5.915 5.915 0 014.22 1.78l-1.51 1.51a1 1 0 00.7 1.71H19a1 1 0 001-1V6.41a1 1 0 00-1.71-.71l-.64.65z"}})])
          )
        }
      }
    